module.exports = __webpack_public_path__ + "img/photo-2-2.4787c5c4.webp";